import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import HealingIcon from "@mui/icons-material/Healing";
import Cards from "../../../components/UI/Cards";
import DisplayDate from "../../../components/DisplayDate";
import { ITriageEmergencyDepartments } from "../../../models/triage";

const translationPath = "components.lastCalls.";

const LastTriageCard = ({
  triage,
  onUseSymptom,
}: {
  triage: ITriageEmergencyDepartments;
  onUseSymptom: (symptoms: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Cards width={"100%"}>
      <Stack
        width={"100%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"start"}
      >
        <Stack
          width={"100%"}
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
        >
          <Stack width={"50%"}>
            <DisplayDate
              typography={{ fontWeight: "bold" }}
              format="DD/MM/YYYY - HH:mm"
            >
              {dayjs(triage.created)}
            </DisplayDate>
          </Stack>
          <Stack
            width={"50%"}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"end"}
            alignItems={"center"}
          >
            <Tooltip title={t(translationPath + "use_symptoms")}>
              <IconButton onClick={() => onUseSymptom(triage.anamnesis)}>
                <HealingIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
        <Stack width={"100%"} display={"flex"} flexDirection={"row"} gap={1}>
          <Typography
            style={{
              width: "100%",
              maxHeight: 100,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
            }}
          >
            <Typography
              sx={(theme) => ({
                mr: 1,
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.grey[700]
                    : theme.palette.grey[400],
              })}
              component={"span"}
            >
              {t(translationPath + "symptoms")}:
            </Typography>
            {triage.anamnesis}
          </Typography>
        </Stack>
      </Stack>
    </Cards>
  );
};

export default LastTriageCard;
